import { Typography, styled } from '@mui/material';
import { referralModel } from './ReferralModel';
import { TPortalCustomization } from './sections/utils';

interface ViewHeaderProps {
    className?: string;
}

const phoneNumberMap = new Map<TPortalCustomization, string>([
    ['Default', '866‑697‑2680'],
    ['Navigere', '800-595-7173'],
]);

function ViewHeaderComponent({ className }: ViewHeaderProps) {
    
    const { customization } = referralModel.state.use();
    const phoneNumber = phoneNumberMap.get(customization) || phoneNumberMap.get("Default");

    return (
        <div className={className}>
            <Typography variant="h1">
                Submit a Referral
            </Typography>
            <Typography variant="body2">
                Use the form below to submit your referral. This is the best way to get your referral to us and helps ensure faster, more accurate processing. 
                If your request is urgent, you can contact us by phone at <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>, Monday–Friday, 8:00 AM – 6:00 PM ET.
            </Typography>
        </div>
    );
}

export const ViewHeader = styled(ViewHeaderComponent, { name: 'ViewHeader' })(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    rowGap: theme.spacing(3),
    padding: theme.spacing(4, 6, 0, 6),
    width: '100%',
    boxSizing: 'border-box'
}));